import {Component, OnInit} from '@angular/core';
import {AfterViewInit, OnDestroy, ViewChild} from '@angular/core';
import {ApiIntegration} from '../_services/api.integration';
import {Globals} from '../_models/globals';
import {DataTableDirective} from 'angular-datatables';
//import {LocalStorageService, SessionStorageService, LocalStorage, SessionStorage} from 'angular-web-storage';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {Router, ActivatedRoute} from '@angular/router';
import {User} from '../_models/user';
import {Subject} from 'rxjs';
import {Register} from '../_models/register';
import {Product} from '../_models/product';
import {productList} from '../_models/productList';
import {KitComponent} from '../_models/kitComponent';
import * as _ from "lodash";
import {AlertService} from '../_services/alert.service';
import { OrderLine } from '../_models/orderLine';

@Component({
  selector: 'app-track-outbound-order',
  templateUrl: './track-outbound-order.component.html',
  styleUrls: ['./track-outbound-order.component.scss'],
})
export class TrackOutboundOrderComponent implements OnInit {

  stockEntryHeader: any;
  getTrackOrderData: any;
  getCarrierTrackOrderData : any;
  estimatedDelivery: any;
  trackingNumber: any;
  shippingOption: any;
  order: any;
  returnReasons: any;
  cancelReasons: any;
  cancelReasonError: any;
  reason: string;
  reasonError: string;
  customerSupport: boolean = false;
  return: boolean = false;
  displayCancelOrder : String = 'N';
  displayCustomerDisplay : String = 'N';
  displayCreateOrder : String = 'N';
  subject: any;
  description: any;
  orderLines : OrderLine[] = [];
  requests: string = '';
  request: string = '';
  needActionPopup: string = 'N';
  ReattemptRequestPopup: string = 'N';
  escalatePopup: string = 'N';
  otpPopUp: string = 'N';
  returnPopUp: string = 'N';
  cancelPopUp: string = 'N';
  actionInstructions: string;
  needActionReason: string;
  viewCustomer : any={};
  addresses:any;
  actionReasons: any = [];
  timerDisplayValue: string = "30:00";
  reEnterPassword: string = "";
  errorMessage: string = "";
  successMessage: string = "";
  otpError: string = "";
  otp: string = "";
  confirm: string = "";
  password1: string = "";
  password2: string = "";
  password3: string = "";
  password4: string = "";
  countDown: any = 30;
  interval: any;
  str: any;
  totalDuration: number = 60 * 30;
  reverseArray:any;
  singleStatus:any;
  requestOtp: string = "";
  cancelReason: string;
  trackingMenuList: any;
  track1: any;
  imageUrlMobile: any;
  imageUrl: any;
  resp = {};
  meta = {};
  status : string ;

  constructor(private alertService: AlertService, private http: HttpClient, private router: Router, public route: ActivatedRoute, private api: ApiIntegration, private g: Globals, public user: User, public register: Register) {
   //this.getApi();
   this.viewPage();
   this.actionReasons = [
     {label: 'Contact information not appropriate', config: 'COMMUNICATION_INFO_ISSUE'},
     {label: 'Issue with Inventory', config: 'STOCK_ISSUE'}
   ];
 }

  getApi(){
    this.api.getStockTransferDetailsIdPublic(this.route.snapshot.params['id'], "1").subscribe((data: any) => {
        this.order = data;
        this.orderLines = _.cloneDeep(this.order.lines);
        this.g.loaderDisplay = "";
        this.orderLines.forEach((d)=>{
          d['previousQuantity']=d.quantity;
        });
        this.g.loaderDisplay = "";
        this.trackingNumber = data.trackingNumbers;
        this.shippingOption = data.shippingOption;
        this.trackOrder();
        this.g.loaderDisplay = "";
    }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
    });
  }

getTrackMenuList(){
  this.g.loaderDisplay = "display";
  this.api.getTrackingMenuLiPblic(this.order.accountOwnerId, this.user.organizationId).subscribe((data : any) => {
  this.g.loaderDisplay ="";
  this.trackingMenuList = data.trackingMenuList;
  } ,
  err => {
        this.g.loaderDisplay = "";
        this.alertService.error('Error', err);
      });
  }

   getTrackBanner(){
   this.g.loaderDisplay = "display";
     this.api.getTrackingBannerPublic(this.order.accountOwnerId,this.user.organizationId).subscribe((data : any) => {
     this.g.loaderDisplay ="";
     this.track1 = data;
     this.imageUrlMobile = this.track1.mobileBanner;
     this.imageUrl = this.track1.webBanner;
     } ,
     err => {
           this.g.loaderDisplay = "";
           this.alertService.error('Error', err);
         });
   }

   viewPage() {
    this.g.loaderDisplay = "display";
    this.api.getOrderDataByIdPublic(this.route.snapshot.params['id'], this.route.snapshot.params['jhiUserId'],"1").subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.order = data;
      this.status = this.order.orderStatus;
      this.getTrackMenuList();
      this.getTrackBanner();
          this.str = (this.order.mobileNumber);
          this.str = this.str ? this.str.toString().replace(/\d(?=\d{3})/g, "*") : this.str;
      //this.lines = this.order.lines;
      this.trackOrder();
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  trackingInformation(){
    this.api.getOrderTrackingDetails(this.route.snapshot.params['id']).subscribe((data: any) => {
        this.order = data;
        this.orderLines = _.cloneDeep(this.order.lines);
        this.g.loaderDisplay = "";
        this.orderLines.forEach((d)=>{
          d['previousQuantity']=d.quantity;
        });
        this.g.loaderDisplay = "";
        this.trackingNumber = data.trackingNumbers;
        this.shippingOption = data.shippingOption;
        this.trackOrder();
        this.g.loaderDisplay = "";
    }, err => {
        console.log(err);
        this.g.loaderDisplay = "";
    });
  }

requestPopup(requests){
this.request = requests;
if(this.request === 'DateAndTimeChanges'){
  this.ReattemptRequestPopup = 'Y';
  this.viewCustomer = {
      "code" : "200",
      "message" : "Success",
      "role" : null,
      "organizationId" : 1,
      "id" : 1,
      "accountType" : "ACCOUNT_OWNER",
      "companyName" : "Test123",
      "ownerName" : "Sandeep",
      "mobile" : 8904291446,
      "email" : "sandeep@snithik.com",
      "status" : "ACTIVE",
      "panCard" : "NO",
      "panCardNumber" : null,
      "aadharCard" : "NO",
      "aadhartCardNumber" : null,
      "mouDocument" : "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList" : [ {
        "aoId" : 1,
        "address1" : "Test",
        "address2" : "SuperMarket",
        "city" : "Hyderabad",
        "state" : "Telangana",
        "country" : "",
        "addressType" : "BILLING",
        "addressText" : "Test, , Hyderabad, Telangana, 500089",
        "zip" : "500089",
        "organizationId" : 1,
        "addressId" : 2,
        "geoCode" : null
      } ],
      "addressId" : null,
      "createdBy" : null,
      "createdDate" : "26-09-2021",
      "updatedBy" : null,
      "updatedDate" : "08-10-2021",
      "expiryDate" : "03-10-2021",
      "gstNumber" : null
    }
}
if(this.request === 'alternateLocation'){
  this.ReattemptRequestPopup = 'Y';
  this.viewCustomer = {
      "code" : "200",
      "message" : "Success",
      "role" : null,
      "organizationId" : 1,
      "id" : 1,
      "accountType" : "ACCOUNT_OWNER",
      "companyName" : "Test123",
      "ownerName" : "Sandeep",
      "mobile" : 8904291446,
      "email" : "sandeep@snithik.com",
      "status" : "ACTIVE",
      "panCard" : "NO",
      "panCardNumber" : null,
      "aadharCard" : "NO",
      "aadhartCardNumber" : null,
      "mouDocument" : "https://shift-images.s3.ap-south-1.amazonaws.com/Img-26-09-2021-8-49-35Before%20change.txt",
      "adddressList" : [ {
        "aoId" : 1,
        "address1" : "Test",
        "address2" : "SuperMarket",
        "city" : "Hyderabad",
        "state" : "Telangana",
        "country" : "",
        "addressType" : "BILLING",
        "addressText" : "Test, , Hyderabad, Telangana, 500089",
        "zip" : "500089",
        "organizationId" : 1,
        "addressId" : 2,
        "geoCode" : null
      } ],
      "addressId" : null,
      "createdBy" : null,
      "createdDate" : "26-09-2021",
      "updatedBy" : null,
      "updatedDate" : "08-10-2021",
      "expiryDate" : "03-10-2021",
      "gstNumber" : null
    }
}
if(this.request === 'cancellation'){
      this.needActionPopup = 'Y';
}
if(this.request === 'pickupFromCarrier'){
      this.escalatePopup = 'Y';
}

}



closeRequestPoup(){
if(this.request === 'DateAndTimeChanges'){
   this.ReattemptRequestPopup = 'N';
}
if(this.request === 'alternateLocation'){
   this.ReattemptRequestPopup = 'N';
}
if(this.request === 'cancellation'){
   this.needActionPopup = 'N';
}
if(this.requests === 'pickupFromCarrier'){
      this.escalatePopup = 'N';
}
this.requests = '';
}


  displayRoute(){
  document.getElementById('div3').classList.add("d-none");
                document.getElementById('div4').classList.add("d-none");
                document.getElementById('div1').classList.remove("d-none");
  }
  cancelOrderDisplayDisplay(){
              document.getElementById('div1').classList.add("d-none");
              document.getElementById('div4').classList.add("d-none");
               document.getElementById('div3').classList.remove("d-none");
               this.getReasons();
  }
  CustomerSupportDisplay(){
              document.getElementById('div1').classList.add("d-none");
              document.getElementById('div3').classList.add("d-none");
                 document.getElementById('div4').classList.remove("d-none");
  }

  CSDisplay() {
    let x = document.getElementById("csorder");
    if (x.style.display === "none") {
      x.style.display = "block";
      this.customerSupport = true;
    } else {
      x.style.display = "none";
      this.customerSupport = false;
    }
  }
  ReturnOrder() {
  this.getReasons();
    let x = document.getElementById("re-order");
    if (x.style.display === "none") {
      x.style.display = "block";
      this.return = true;
    } else {
      x.style.display = "none";
      this.return = false;
    }
  }

  ngOnInit() {
  }

/*   trackOrder() {
    this.api.trackOrderForShiftAggregator(this.shippingOption, this.order.orderHeaderId,this.order.orderType,this.trackingNumber).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getTrackOrderData = data.trackOrder;

    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  } */

  navigate(){
  this.router.navigate(['/trackingOutBoundOrder/' + this.order.orderHeaderId + '/' + this.order.accountOwnerId]);
  }


  trackOrder() {
    this.api.getOrderTrackingDetailsPublic(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.getTrackOrderData = data.trackOrder;
      this.getCarrierTrackOrderData = data.trackCarrierOrder;
      this.estimatedDelivery = data.estimatedDelivery;
      this.reverseArray = data.trackOrder;
      this.singleStatus = this.reverseArray[0].status;

    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  getReasons(){
    this.api.getValuesPublic("1", 'ACCOUNT_OWNER', this.order.accountOwnerId || this.user.accountOwnerId, 'REASON').subscribe((data: any) => {
        this.returnReasons = data.tripleSetConfigDTOS;
      }, err => {
        console.log(err);
      });
  }

  getCancelReasons(){
    this.api.getValuesPublic("1", 'OUTBOUND', 'CANCEL_REASON', 'Outbound Orders').subscribe((data: any) => {
        this.cancelReasons = data.tripleSetConfigDTOS;
      }, err => {
        console.log(err);
      });
  }

 Submit(){
 this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
      this.http.post(environment.apiUrl + 'api/public/createReturnOrders',  {
      "accountOwnerContactId": this.order.accountOwnerCustomerId,
      "accountOwnerId": this.order.accountOwnerId,
      "additionalInfo": this.order.additionalInfo,
      "lines": this.orderLines,
      "awbNumber": this.order.awbNumber,
      "connectionName": this.order.connectionName,
      "deliveryInstructions": this.order.deliveryInstructions,
      "externalOrderId": this.order.sourceOrderId || '',
      "externalShipmentId": "string",
      //"inProcessDate": "2020-10-01T02:22:36.391Z",
      "orderNumber": this.order.orderNumber,
      "orderStatus": "SUBMITTED",
      "orderType": this.order.orderType,
      "organizationId": 1,
      "originalOrderDate": this.order.createdDate,
      "originalOrderHeaderId": this.order.orderHeaderId,
      "pickupAddressId": 0,
      "productConfig": this.order.productConfig,
      "providerStatus": this.order.providerStatus,
      "receivedDate": "2020-10-01T02:22:36.392Z",
      "referenceOrderId": "string",
      "returnOrderDate": "string",
      "returnOrderHeaderId": 0,
      "returnReason": this.reason,
      //"shipmentPrice": 0,
      "shippingMethod": this.order.shippingMethod,
      "shippingOption": this.order.shippingOption,
      "sourceOrderDate": this.order.sourceOrderDate,
      //"sourceType": "string",
      //"trackingNumber": this.order.trackingNumber,
      "warehouseId": this.order.warehouseId
    },
        {headers: header1}).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
             this.alertService.success('Order','Return Successfully');
             this.getApi();
        }
        else{
                 this.alertService.error('Error',data['message']);
                 }
        },
        (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        });
    }

      supportTicketCreate() {
          var header1 = new HttpHeaders();
             header1 = header1.append('Content-Type', 'application/json');
             header1 = header1.append('Accept', 'application/json');
             header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
             this.http.post(environment.apiUrl + 'api/public/createSupportTicket', {
              "accountOwnerId": this.order.accountOwnerId,
              "category": "Fulfilment Related",
              "description": this.description,
              "organizationId": this.user.organizationId,
              "subject": this.subject,
              "userId": this.user.userId
            },
            {headers: header1}).subscribe(data => {
            this.g.loaderDisplay = "";
                if (data['code'] == 200) {
                  this.alertService.success('Ticket','Created Successfully');
                  this.getApi();
                }
            },
          (err) => {
            this.g.loaderDisplay = "";
            this.alertService.error('Error',err);
          });
      }

  keytab(event, val1, val2) {
    if (event.key == 'Backspace') {
      document.getElementById(val2).focus();
    } else {
      document.getElementById(val1).focus();
    }
  }

  submitOtp(requestOtp){
  this.otpPopUp = 'Y';
  this.requestOtp = requestOtp;
  this.str = (this.order.receiverMobile);
  this.str = this.str ? this.str.toString().replace(/\d(?=\d{3})/g, "*") : this.str;
  this.submitResend();
  }

  closeOtpPopup(){
  this.otpPopUp = 'N';
  this.requestOtp = "";
  }

  startTimer(duration) {
    let timer = duration, minutes, seconds;
    let timeNew = this.timerDisplayValue;
    this.interval = setInterval(() => {
      minutes = parseInt(timer / 60 + "", 10)
      seconds = parseInt(timer % 60 + "", 10);
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;
      this.timerDisplayValue = minutes + ":" + seconds;
      if (--timer < 0) {
        timer = duration;
      }
      //console.log(this.timerDisplayValue);
      //console.log(timerNew);
    }, 1000);
    //console.log(timerNew);
  }

  stopTimerFunction() {
    clearInterval(this.interval);
    this.timerDisplayValue = "30:00";
  }



  submitResend() {
    this.stopTimerFunction();
    this.successMessage = "";
    this.errorMessage = "";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.password1 = "";
    this.password2 = "";
    this.password3 = "";
    this.password4 = "";
    this.http.post(environment.apiUrl + 'api/public/generateOTP?mobileNumber=' + this.order.receiverMobile + "&organizationId=" + this.user.organizationId,
      {
        headers: header1
      }).subscribe(data => {
        if (data['code'] == 200) {
          this.successMessage = data['message'];
          this.startTimer(this.totalDuration);
        } else {
          this.errorMessage = "invalid otp";
          if (data['code'] == 400) {
            this.errorMessage = data['message'];
          }
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "Failed OTP Generation, please retry.";
      }
    );
  }


  verifyOtp() {
    this.otp = this.password1.toString() + this.password2.toString() + this.password3.toString() + this.password4.toString();
    this.successMessage = "";
    this.errorMessage = "";
    if (!this.otp) {
      this.errorMessage = "Please Enter OTP";
    }
    if (this.errorMessage != "") {
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    this.http.post(environment.apiUrl + 'api/public/validateOtp', {
        "mobileNumber": this.order.receiverMobile,
        "otp": this.otp
      },
      {headers: header1}
    ).subscribe(data => {
        if (data['code'] == 200) {
          this.successMessage = "OTP Created Successfully";
          /* this.router.navigate(['/trackOutBoundOrder/' + this.order.orderHeaderId + '/' + this.order.accountOwnerId]); */

          this.otpPopUp = "N";
          this.router.navigate(['/trackOutBoundOrder/' + this.order.orderHeaderId + '/' + this.order.accountOwnerId]);
          /* if(this.requestOtp == 'return'){
          this.returnPopUp = "Y";
          this.getReasons();
          }
          else if(this.requestOtp == 'cancel') {
          this.cancelPopUp = "Y";
          this.getCancelReasons();
          }
          else{

          } */
        } else {
          this.errorMessage = data['message'];
        }
      },
      (err: HttpErrorResponse) => {
        console.log(err);
        this.errorMessage = "otp Failed, please re-try.";
      }
    )
  }

  submitReturnOrder() {

  this.reasonError = "";
  if(!this.reason){
  this.reasonError = 'please select reason';
  return false
  }

  let orderLine = {
  orderLineId: 0,
  returnQuantity: 0
  };
      let linesArray = [];
        for(let or of this.order.lines){
      if(or.productName){
      orderLine.orderLineId = or.orderLineId;
      orderLine.returnQuantity = or.quantity;
      linesArray.push(_.cloneDeep(orderLine));
      }
     }
    var header1 = new HttpHeaders();
       header1 = header1.append('Content-Type', 'application/json');
       header1 = header1.append('Accept', 'application/json');
       header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
       this.http.post(environment.apiUrl + "api/public/orders/"+this.order.orderNumber +"/return-orders", {
        "accountOwnerId": this.order.accountOwnerId,
        "orderHeaderId": this.order.orderHeaderId,
        "orderLines": linesArray,
        /* "orderStatus": "RETURN", */
        "organizationId": this.order.organizationId,
        "returnReason": this.reason
      },
      {headers: header1}).subscribe(data => {
      this.g.loaderDisplay = "";
      this.resp = data;
      this.meta = data["metadata"];
          if (this.meta['responseCode']== 0) {
            this.alertService.success('Return','Successfully');
            this.returnPopUpClose();
            this.router.navigate(['/trackOutBoundOrder/' + this.order.orderHeaderId + '/' + this.order.accountOwnerId]);

           // this.viewPage();
          }
          else{
            this.alertService.error('Error',this.meta['responseMessage']);
            this.returnPopUpClose();
          }
      },
    (err) => {
      this.g.loaderDisplay = "";
      this.alertService.error('Error',err);
    });
  }


   submitCancelOrder() {

   this.cancelReasonError = "";
   if(!this.cancelReason){
   this.cancelReasonError = 'please select reason';
   return false
   }

     var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        this.http.post(environment.apiUrl + 'api/public/updateOrderH&L', {
         "accountOwnerId": this.order.accountOwnerId,
         "orderHeaderId": this.order.orderHeaderId,
         "shippingOption": this.order.shippingOption,
         "orderStatus": "CANCELLED",
         "organizationId": this.order.organizationId,
         "cancelReason": this.cancelReason
       },
       {headers: header1}).subscribe(data => {
       this.g.loaderDisplay = "";
           if (data['code'] == 200) {
             this.alertService.success('Cancelled','Successfully');
             this.cancelPopUpClose()
             this.viewPage();
           }
           else{
             this.alertService.error('Error',data['message']);
           }
       },
     (err) => {
       this.g.loaderDisplay = "";
       this.alertService.error('Error',err);
     });
   }

  returnPopUpClose(){
  this.returnPopUp = 'N';
  this.returnReasons = [];
  this.reasonError = "";
  }

  cancelPopUpClose(){
  this.cancelPopUp = 'N';
  this.cancelReasons = [];
  this.cancelReasonError = "";
  }

}
